import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../data/mock';
import { HelpCircle } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const FAQSection = () => {
  const [headerRef, headerVisible] = useScrollAnimation({ threshold: 0.2 });
  const [contentRef, contentVisible] = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="faq" className="faq-section" data-testid="faq-section">
      <div className="container">
        <div 
          ref={headerRef}
          className={`section-header animate-slide-up ${headerVisible ? 'is-visible' : ''}`}
        >
          <span className="section-tag">Got Questions?</span>
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">
            Everything you need to know about the course
          </p>
        </div>

        <div 
          ref={contentRef}
          className={`faq-container animate-fade-in ${contentVisible ? 'is-visible' : ''}`}
        >
          <Accordion type="single" collapsible className="faq-accordion">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={faq.id} 
                value={`faq-${faq.id}`} 
                className={`faq-item animate-slide-up ${contentVisible ? 'is-visible' : ''}`}
                style={{ transitionDelay: `${index * 100}ms` }}
                data-testid={`faq-item-${faq.id}`}
              >
                <AccordionTrigger className="faq-trigger">
                  <div className="faq-question">
                    <HelpCircle className="faq-icon" />
                    <span>{faq.question}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="faq-content">
                  <p>{faq.answer}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className={`faq-cta animate-fade-in ${contentVisible ? 'is-visible' : ''} stagger-6`}>
          <p className="faq-cta-text">Still have questions?</p>
          <p className="faq-cta-subtext">Ask our AI assistant or contact us directly</p>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
